export default __webpack_public_path__ + "static/media/brasileira.552a21c7.jpeg";